/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
// @mui
import {
  Stack,
  Container,
  Typography,
  Card,
  Box,
  Button,
  Chip,
  Paper,
  Grid,
  alpha,
  useTheme,
  LinearProgress,
  Divider
} from '@mui/material';
import TableStyle from '../../ui-component/TableStyle';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { getApi } from 'views/services/api';
import {
  Payment as PaymentIcon,
  CheckCircle as ActiveIcon,
  Cancel as ExpiredIcon,
  Warning as WarningSoonIcon,
  Receipt as ReceiptIcon,
  CalendarToday as CalendarIcon,
  Timer as TimerIcon,
  AttachMoney as MoneyIcon,
  TrendingUp as TrendingUpIcon,
  History as HistoryIcon,
  CardMembership as MembershipIcon
} from '@mui/icons-material';

const HotelPaymentsDetails = () => {
  const theme = useTheme();
  const hotelId = JSON.parse(localStorage.getItem('hotelData'))._id;
  const [paymentData, setPaymentData] = useState([]);

  const getAllPaymentsDetails = async () => {
    const response = await getApi(`api/payments/list/?createdBy=${hotelId}`);
    console.log(' response ==> ', response);
    if (response && response.status === 200) {
      setPaymentData(response?.data?.paymentsData);
    }
  };

  useEffect(() => {
    getAllPaymentsDetails();
    // eslint-disable-next-line
  }, []);

  // Función para obtener el estado traducido
  const getStatusSpanish = (status) => {
    switch (status) {
      case 'active':
        return 'Activo';
      case 'expired':
        return 'Vencido';
      case 'expiresSoon':
        return 'Por Vencer';
      default:
        return status;
    }
  };

  // Función para obtener el icono del estado
  const getStatusIcon = (status) => {
    switch (status) {
      case 'active':
        return <ActiveIcon sx={{ fontSize: 16 }} />;
      case 'expired':
        return <ExpiredIcon sx={{ fontSize: 16 }} />;
      case 'expiresSoon':
        return <WarningSoonIcon sx={{ fontSize: 16 }} />;
      default:
        return <ReceiptIcon sx={{ fontSize: 16 }} />;
    }
  };

  // Calcular estadísticas
  const totalPayments = paymentData?.length || 0;
  const totalAmount = paymentData?.reduce((sum, payment) => sum + (payment.amount || 0), 0) || 0;
  const activePayments = paymentData?.filter((payment) => payment.status === 'active')?.length || 0;

  const columns = [
    {
      field: '_id',
      headerName: 'N°',
      flex: 0.5,
      cellClassName: 'name-column--cell--capitalize',
      valueGetter: (index) => index.api.getRowIndexRelativeToVisibleRows(index.row._id) + 1,
      renderCell: (params) => (
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 600,
            fontSize: '0.875rem',
            color: theme.palette.primary.main
          }}
        >
          {params.api.getRowIndexRelativeToVisibleRows(params.row._id) + 1}
        </Box>
      )
    },
    {
      field: 'title',
      headerName: 'Plan Adquirido',
      flex: 1.5,
      cellClassName: 'name-column--cell--capitalize',
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: 2,
              backgroundColor: alpha(theme.palette.secondary.main, 0.1),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <MembershipIcon sx={{ fontSize: 16, color: theme.palette.secondary.main }} />
          </Box>
          <Box>
            <Typography variant="body2" fontWeight={600}>
              {params.value}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Plan de suscripción
            </Typography>
          </Box>
        </Stack>
      )
    },
    {
      field: 'amount',
      headerName: 'Monto Pagado',
      flex: 1,
      cellClassName: 'name-column--cell--capitalize',
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <MoneyIcon sx={{ fontSize: 16, color: theme.palette.success.main }} />
          <Typography variant="body2" fontWeight={600} color="success.main">
            ${params.value?.toLocaleString()} USD
          </Typography>
        </Stack>
      )
    },
    {
      field: 'days',
      headerName: 'Duración',
      flex: 1,
      cellClassName: 'name-column--cell--capitalize',
      renderCell: (params) => {
        return (
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <TimerIcon sx={{ fontSize: 16, color: theme.palette.info.main }} />
            <Typography variant="body2" fontWeight={500}>
              {params.value} días
            </Typography>
          </Stack>
        );
      }
    },
    {
      field: 'createdOn',
      headerName: 'Fecha de Inicio',
      flex: 1.2,
      valueFormatter: (params) => {
        const date = new Date(params.value);
        const dateOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return date.toLocaleString(undefined, dateOptions);
      },
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <CalendarIcon sx={{ fontSize: 14, color: theme.palette.text.secondary }} />
          <Typography variant="body2">
            {new Date(params.value).toLocaleDateString('es-ES', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            })}
          </Typography>
        </Stack>
      )
    },
    {
      field: 'endDate',
      headerName: 'Fecha de Vencimiento',
      flex: 1.2,
      valueGetter: (params) => {
        const startDate = new Date(params.row.createdOn);
        const days = parseInt(params.row.days);
        const endDate = new Date(startDate.getTime() + days * 24 * 60 * 60 * 1000);
        const dateOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return endDate.toLocaleString(undefined, dateOptions);
      },
      renderCell: (params) => {
        const startDate = new Date(params.row.createdOn);
        const days = parseInt(params.row.days);
        const endDate = new Date(startDate.getTime() + days * 24 * 60 * 60 * 1000);
        const isExpiring = params.row.status === 'expiresSoon';

        return (
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <CalendarIcon
              sx={{
                fontSize: 14,
                color: isExpiring ? theme.palette.warning.main : theme.palette.text.secondary
              }}
            />
            <Typography variant="body2" color={isExpiring ? 'warning.main' : 'text.primary'} fontWeight={isExpiring ? 600 : 400}>
              {endDate.toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
              })}
            </Typography>
          </Stack>
        );
      }
    },
    {
      field: 'status',
      headerName: 'Estado',
      flex: 1,
      renderCell: (params) => {
        let chipColor;
        let chipVariant = 'filled';

        switch (params.value) {
          case 'active':
            chipColor = 'success';
            break;
          case 'expired':
            chipColor = 'error';
            break;
          case 'expiresSoon':
            chipColor = 'warning';
            break;
          default:
            chipColor = 'default';
            chipVariant = 'outlined';
            break;
        }

        return (
          <Chip
            label={getStatusSpanish(params.value)}
            color={chipColor}
            variant={chipVariant}
            size="small"
            icon={getStatusIcon(params.value)}
            sx={{
              borderRadius: 2,
              fontWeight: 600,
              fontSize: '0.75rem',
              minWidth: 100
            }}
          />
        );
      }
    }
  ];

  return (
    <>
      <Container maxWidth="xl" sx={{ py: 3 }}>
        {/* Header Section */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            color: 'white',
            borderRadius: 3
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Box>
              <Typography variant="h4" fontWeight={700} gutterBottom>
                Historial de Pagos
              </Typography>
              <Typography variant="body1" sx={{ opacity: 0.9 }}>
                Consulta todos los pagos realizados por suscripciones al sistema
              </Typography>
            </Box>
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              <HistoryIcon sx={{ fontSize: 60, opacity: 0.3 }} />
            </Box>
          </Stack>
        </Paper>

        {/* Statistics Cards */}
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                p: 2.5,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[8]
                }
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.primary.main, 0.1),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <ReceiptIcon sx={{ color: theme.palette.primary.main, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} color="primary">
                    {totalPayments}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Total de Pagos
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                p: 2.5,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.success.main, 0.1)}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[8]
                }
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.success.main, 0.1),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <TrendingUpIcon sx={{ color: theme.palette.success.main, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} color="success.main">
                    ${totalAmount.toLocaleString()}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Total Invertido (USD)
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                p: 2.5,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.info.main, 0.1)}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[8]
                }
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.info.main, 0.1),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <ActiveIcon sx={{ color: theme.palette.info.main, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} color="info.main">
                    {activePayments}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Planes Activos
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>
        </Grid>

        {/* Data Table */}
        <TableStyle>
          <Card
            sx={{
              borderRadius: 3,
              overflow: 'hidden',
              border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              '& .MuiDataGrid-root': {
                border: 'none',
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: alpha(theme.palette.primary.main, 0.05),
                  borderBottom: `2px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                  '& .MuiDataGrid-columnHeader': {
                    fontWeight: 600,
                    fontSize: '0.875rem'
                  }
                },
                '& .MuiDataGrid-row': {
                  '&:hover': {
                    backgroundColor: alpha(theme.palette.primary.main, 0.02)
                  }
                },
                '& .MuiDataGrid-cell': {
                  borderBottom: `1px solid ${alpha(theme.palette.divider, 0.05)}`
                }
              }
            }}
          >
            <Box sx={{ p: 3, pb: 1 }}>
              <Typography variant="h6" fontWeight={600} color="primary">
                Registro de Pagos ({totalPayments})
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Historial completo de todos los pagos realizados por suscripciones
              </Typography>
            </Box>

            <Box sx={{ height: 600, width: '100%' }}>
              <DataGrid
                rows={paymentData ?? []}
                columns={columns}
                getRowId={(row) => row._id}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: {
                      debounceMs: 500,
                      placeholder: 'Buscar pagos...'
                    }
                  }
                }}
                sx={{
                  '& .MuiDataGrid-toolbarContainer': {
                    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                    p: 2
                  }
                }}
              />
            </Box>
          </Card>
        </TableStyle>
      </Container>
    </>
  );
};

export default HotelPaymentsDetails;
